import { HiOutlineExclamationCircle } from "react-icons/hi";
import { Link } from "react-router-dom";
import { Modal } from "../layout/Modal";
import { cn } from "../lib/utils";
import { Button } from "./Button";
import { Card } from "./Card";

export const ErrorFallbackUI = ({ resetErrorBoundary }: { resetErrorBoundary: () => void }) => {
	return (
		<Modal>
			<Card className="flex flex-col items-center gap-y-[24px] p-[24px] w-[500px] max-w-[500px]">
				<div
					className={cn(
						"flex space-x-[28px] w-full px-[28px] py-[22px] border border-opacity-40 rounded",
						"border-red-500 bg-red-50 text-red-600/90",
					)}
				>
					<HiOutlineExclamationCircle className="text-[32px] stroke-[1.75] shrink-0 mt-[3px]" />
					<div className="flex flex-col space-y-[10px]">
						<span className="text-[20px] font-semibold">Something has gone wrong</span>
						<span className="text-[15px] font-medium whitespace-pre-line">
							<p>{`An inRev engineer has been notified of your issue and is investigating. \n\n Apologies for the inconvenience.`}</p>
						</span>
					</div>
				</div>
				<Link to={`/`} className="w-full flex justify-center">
					<Button onClick={resetErrorBoundary} color="inverse" filled className="w-1/2">
						OK
					</Button>
				</Link>
			</Card>
		</Modal>
	);
};
